// extracted by mini-css-extract-plugin
module.exports = {"arrowUp":"styles_arrowUp__k5HTI"};